import { ComponentPropsWithoutRef, PropsWithChildren } from 'react';
import clsx from 'clsx';
import Image from '@/components/shared/Image';

import './styles.css';

interface BackgroundImageProps extends PropsWithChildren {
  image: {
    url: string;
    alt: string;
  };
  textPosition?: 'left' | 'right';
}

type BackgroundImageAdditionalProps = Omit<
  ComponentPropsWithoutRef<'div'>,
  keyof BackgroundImageProps
>;

export const FullscreenImage = ({
  children,
  image,
  textPosition = 'left'
}: BackgroundImageProps & BackgroundImageAdditionalProps) => {
  return (
    <div className="fullscreen-banner">
      <div
        className={clsx(
          'fullscreen-banner__img',
          textPosition === 'left'
            ? 'fullscreen-banner__img--overlay-left'
            : 'fullscreen-banner__img--overlay-right'
        )}
      >
        {image && (
          <Image
            src={image.url}
            alt={image.alt}
            sizes="100vw"
            className="object-cover object-center"
            fill
          />
        )}
      </div>
      <div
        className={clsx(
          'fullscreen-banner__text',
          textPosition === 'left' ? 'justify-start' : 'justify-end'
        )}
      >
        <div className="box-content w-full px-6 py-12 lg:px-12 2xl:px-20 3xl:mx-auto 3xl:max-w-7xl 3xl:px-0">
          <div className="lg:max-w-screen-sm 2xl:max-w-[42.5rem]">{children}</div>
        </div>
      </div>
    </div>
  );
};
